import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
const GOALS = ['Protect my parents from scams', "Stop being the family's IT person", 'Make sure my family is actually safe', 'Understand where we may be at risk', 'Build security habits that actually stick', 'Reduce the amount of spam we receive', "Ensure I'm not our only safety net", 'Recover after something went wrong'];
export function GoalsAssessmentPage() {
  const [selectedGoals, setSelectedGoals] = useState<Set<number>>(new Set());
  const navigate = useNavigate();
  const location = useLocation();
  const toggleGoal = (index: number) => {
    const newSelected = new Set(selectedGoals);
    if (newSelected.has(index)) {
      newSelected.delete(index);
    } else {
      newSelected.add(index);
    }
    setSelectedGoals(newSelected);
  };
  const handleContinue = () => {
    if (selectedGoals.size === 0) return;
    const nextRoute = location.state?.nextRoute || '/assessment/self';
    navigate('/assessment/transition', {
      state: {
        nextRoute
      }
    });
  };
  return <div className="w-full h-screen bg-[#f5f5f7] flex flex-col overflow-hidden" data-id="element-2000">
      {/* Top bar */}
      <div className="w-full px-5 pt-4 pb-2 shrink-0" data-id="element-2001">
        <div className="max-w-md mx-auto flex items-center gap-4" data-id="element-2002">
          <Link to="/assessment" className="flex items-center justify-center w-10 h-10 -ml-2 text-gray-500 hover:text-[#631bb7] transition-colors" aria-label="Go back" data-id="element-2003">
            <ArrowLeftIcon size={22} data-id="element-2004" />
          </Link>
          {/* Progress bar */}
          <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-2005">
            <div className="h-full bg-[#631bb7] rounded-full transition-all duration-500" style={{
            width: '20%'
          }} data-id="element-2006" />
          </div>
        </div>
      </div>

      {/* Question */}
      <div className="flex-1 px-5 pt-3 pb-4 overflow-y-auto hide-scrollbar" data-id="element-2007">
        <div className="max-w-md mx-auto" data-id="element-2008">
          <div className="text-center mb-4" data-id="element-2009">
            <h1 className="md:text-[26px] text-[20px] font-[600] text-[#190647] mb-1" data-id="element-2010">
              What are some of{' '}
              <span className="text-[#631bb7]" data-id="element-2011">your goals</span> when it comes
              to online safety?
            </h1>
            <p className="text-gray-500 text-sm" data-id="element-2012">Select all that apply:</p>
          </div>

          {/* Options */}
          <div className="space-y-2.5" data-id="element-2013">
            {GOALS.slice(0, 6).map((goal, i) => {
            const isSelected = selectedGoals.has(i);
            return <button key={i} onClick={() => toggleGoal(i)} className={`w-full flex items-center px-5 py-3 rounded-xl text-left transition-all duration-200 border-2 ${isSelected ? 'bg-[#631bb7] border-[#631bb7] text-white shadow-md' : 'bg-white border-gray-100 text-[#111111] hover:border-gray-200'}`} data-id="element-2014">
                  <span className="text-[14px] leading-snug font-[500]" data-id="element-2015">
                    {goal}
                  </span>
                </button>;
          })}
          </div>
        </div>
      </div>

      {/* Fixed Bottom Action Bar */}
      <div className="w-full bg-[#f5f5f7] px-5 pt-2 pb-6 shrink-0" data-id="element-2016">
        <div className="max-w-md mx-auto" data-id="element-2017">
          <button onClick={handleContinue} disabled={selectedGoals.size === 0} className={`w-full py-3.5 rounded-xl font-semibold text-white transition-all ${selectedGoals.size === 0 ? 'bg-[#631bb7] opacity-50 cursor-not-allowed' : 'bg-[#631bb7] hover:bg-[#521099] shadow-md'}`} data-id="element-2018">
            Continue
          </button>
        </div>
      </div>
    </div>;
}